import { z } from "zod";
import { ErrorIdSchema } from "./common.js";

export const HerSkinErrorCodeSchema = z.enum([
  "AUTH_REQUIRED",
  "REAUTH_REQUIRED",
  "FORBIDDEN",
  "NOT_FOUND",
  "CONFLICT",
  "REVISION_CONFLICT",
  "RATE_LIMITED",
  "ADAPTER_OFFLINE",
  "ADAPTER_RECONNECTING",
  "ADAPTER_INCOMPATIBLE",
  "UNSUPPORTED",
  "REMOTE_BUSY",
  "REMOTE_TIMEOUT_UNKNOWN",
  "VALIDATION_FAILED",
  "SECRET_REQUIRED",
  "CONTROLLER_UNAVAILABLE",
  "INTERNAL_ERROR",
]);

export const FieldIssueSchema = z
  .object({
    path: z.array(z.union([z.string(), z.number().int().min(0)])).max(16),
    code: z.string().min(1).max(80),
    message: z.string().min(1).max(500),
  })
  .strict();

export const HerSkinErrorSchema = z
  .object({
    code: HerSkinErrorCodeSchema,
    message: z.string().min(1).max(1000),
    retryable: z.boolean(),
    errorId: ErrorIdSchema,
    fieldIssues: z.array(FieldIssueSchema).max(100).optional(),
  })
  .strict();

export const ErrorResponseSchema = z
  .object({
    error: HerSkinErrorSchema,
  })
  .strict();

/** API/WS 边界中的标准错误对象，不含 response wrapper。 */
export const ApiErrorSchema = HerSkinErrorSchema;
export const ApiErrorResponseSchema = ErrorResponseSchema;

export type HerSkinErrorCode = z.infer<typeof HerSkinErrorCodeSchema>;
export type HerSkinError = z.infer<typeof HerSkinErrorSchema>;
export type ApiError = z.infer<typeof ApiErrorSchema>;
export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;
export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;
